import type { TemplateMeta } from '../../types';
import { getDefaultRange, getRangeForAnchor } from './dateRange';
import { WeekIcon } from './Icon';

export const plannerWeekMeta: TemplateMeta = {
  name: 'Week',
  orientation: 'landscape',
  Icon: WeekIcon,
  theme: 'block',
  eventListDisplayCustomLabel: 'Week',
  eventListDisplayFullLabel: null,
  eventListRangePicker: 'week-monday',
  getDefaultRange,
  getRangeForAnchor,
  featureFlag: 'standalonePlannerPrintableEnabled',
};
